import { find } from '../utils/dom'

export default function (props = {}) {
	// Defaults
	const opts = {
		selector: '[js-header]',
		fixedOnScrool: true,
		animateOnFixed: false,
		background: true,
		topReduce: 40,
		translate: true,
		...props,
	}

	const header = find(opts.selector)
	let lastScrollTop = 0

	function onScroll() {
		window.addEventListener('scroll', () => {
			if (document.body.classList.contains('haveLoader')) {
				if (!document.body.classList.contains('loaded')) return
			}

			const currentScroll = window.pageYOffset || document.documentElement.scrollTop
			const point = currentScroll > opts.topReduce

			if (opts.background) {
				background(point || header.classList.contains('menu-dark'))
			}

			if (!point) {
				translate(true)
				lastScrollTop = 0
				return
			}

			if (currentScroll > lastScrollTop) {
				translate(false)
			} else if (currentScroll < lastScrollTop) {
				translate(true)
			}

			lastScrollTop = currentScroll <= 0 ? 0 : currentScroll
		})
	}

	/*** @param {boolean} value */
	function fixed(value, animate = false) {
		header.setAttribute('js-header-fixed', value)
		// animate && header.setAttribute('js-header-animate', value)
	}
	/*** @param {boolean} value */
	function translate(value) {
		header.setAttribute('js-header-translate', value)
	}

	/*** @param {boolean} value */
	function background(value) {
		header.setAttribute('js-header-background', value)
	}

	function init() {
		if (header) {
			header.setAttribute('js-header-translate', true)
			if (opts.fixedOnScrool) fixed(true)
			if (opts.background) {
				const currentScroll = window.pageYOffset || document.documentElement.scrollTop
				background(currentScroll > opts.topReduce || header.classList.contains('menu-dark'))
			}
			onScroll()
		}
		return this
	}

	return {
		init,
		header,
		opts,
		fixed,
		reduce: background,
	}
}
